import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

const getCurrentTags = () => {
    // Annahme: Die URL hat GET-Parameter namens 'tags'
    let url = new URL(window.location.href);
    return url.searchParams.get('tag');
}

let pageNumber = 1
const tagButtons = document.querySelectorAll('.toolbar__end .btn[data-slug], .sidesheet__content div[data-slug]');
const buttonMore = document.querySelector('[data-xperience-loadmore="#articles_main"]')

const createSpinner = () => {
    // Erstelle das div-Element
    const loadingSpinner = document.createElement('div');

// Setze die Styles
    loadingSpinner.style.display = 'none';
    loadingSpinner.style.backgroundColor = 'rgba(255, 255, 255, 0.75)';
    loadingSpinner.style.textAlign = 'center';
    loadingSpinner.style.position = 'fixed';

// Füge Klassen hinzu
    loadingSpinner.classList.add('loading-spinner');

// Setze ARIA-Attribute
    loadingSpinner.setAttribute('aria-live', 'polite');
    loadingSpinner.setAttribute('aria-busy', 'true');
    loadingSpinner.setAttribute('aria-label', 'Inhalt wird geladen...');
    loadingSpinner.setAttribute('tabindex', '0');

// Erstelle das span-Element
    const spinnerIcon = document.createElement('span');
    spinnerIcon.classList.add('loading-spinner__icon');

// Füge das span-Element als Kind hinzu
    loadingSpinner.appendChild(spinnerIcon);

// Füge das Element in den DOM ein, z.B. in den body
    document.body.appendChild(loadingSpinner);
}

setTimeout(() => {
    const select = document.querySelector('#blog-categories');
    const dropdownButton = document.querySelector('.dropdown__button');
    const dropdownMenu = document.querySelector('.dropdown__menu');
    const dropdownItems = document.querySelectorAll('.dropdown__list-item');
// Event-Listener für die Dropdown-Elemente
    dropdownItems && (
        dropdownItems.forEach(item => {
            item.addEventListener('click', function() {
                // Wert des Select-Elements aktualisieren
                select.value = this.getAttribute('value');

                // Change-Ereignis auslösen
                select.dispatchEvent(new Event('change'));
            });
        })
    )
    select && (
        select.addEventListener('change', function() {
            const selectedValue = select.value;
            const urlParams = new URLSearchParams(window.location.search);

            if(selectedValue) {
                urlParams.set('category', selectedValue);
                // URL aktualisieren
                window.history.replaceState({}, '', window.location.pathname + '?' + urlParams);

                // Sprache aus URL extrahieren
                const pathParts = window.location.pathname.split('/');
                const lang = pathParts[1] || 'de';

                let params = new URLSearchParams();
                params.append('type', '242424');
                // @ts-ignore
                if(urlParams.get('tag')){
                    params.append('tag', urlParams.get('tag').split(','))
                }
                if(urlParams.get('category')) {
                    params.append('category', urlParams.get('category') ?? '')
                }
                let url = `/${lang}/?` + params.toString();

                // @ts-ignore
                fetch(url)
                    .then(response => response.json())
                    .then(data => {
                        const container = document.querySelector('.wall')
                        if(data && container) {
                            container.innerHTML = data.result

                            var msnry = new Masonry( '.wall', {"percentPosition": true, "originLeft": true })
                            msnry.layout()
                            document.querySelector('.loading-spinner').style.display = 'none'

                            const bricks = document.querySelectorAll('.wall__brick')
                            if (bricks.length >= data.itemsTotal) {
                                buttonMore.style.display = "none"
                            } else {
                                buttonMore.style.display = "inline-flex"
                            }
                        }
                    })
                    .catch(error => console.error('Error:', error));
            }
        })
    )
},500)
// Event-Listener hinzufügen, der auf Änderungen im Select-Feld reagiert


document.addEventListener('DOMContentLoaded', () => {
    createSpinner();

    let urlParams = new URLSearchParams(window.location.search);
    // @ts-ignore
    if(!urlParams.get('tag')) {
        document.querySelector('#all-tags')?.classList.add('btn--active')
    }
    if(urlParams.has('category')) {
        // ausgewählte Category aus der URL in dem Dropdown auswählen bei onload
    }

});

//Update tags by click
tagButtons.forEach(button => {

    button.addEventListener('click', () => {
        const slug = button.getAttribute('data-slug');
        const urlParams = new URLSearchParams(window.location.search);

        // Sprache aus URL extrahieren
        const pathParts = window.location.pathname.split('/');
        const lang = pathParts[1] || 'de';

        document.querySelector('.loading-spinner').style.display = 'flex'

        // Überprüfen, ob der Tag bereits aktiv ist
        if (urlParams.has('tag')) {
            const tags = urlParams.get('tag').split(',');

            if (tags.includes(slug)) {
                // Tag entfernen
                const newTags = tags.filter(tag => tag !== slug);
                urlParams.set('tag', newTags.join(','));
            } else {
                // Tag hinzufügen
                tags.push(slug);
                urlParams.set('tag', tags.join(','));
            }
        } else {
            // Tag hinzufügen, wenn noch keine vorhanden sind
            urlParams.set('tag', slug);
        }


        // URL aktualisieren
        window.history.replaceState({}, '', window.location.pathname + '?' + urlParams);

        //Buttons class aktualisieren
        tagButtons.forEach(tagbutton => {
            // Button-Klasse aktualisieren
            if (tagbutton.classList.contains('btn')) {
                // Wenn der Button die Klasse 'btn' hat
                tagbutton.classList.toggle('btn--active', urlParams.get('tag').split(',').includes(tagbutton.getAttribute('data-slug')));
            } else {
                // Wenn der Button nicht die Klasse 'btn' hat
                tagbutton.classList.toggle('card--selected', urlParams.get('tag').split(',').includes(tagbutton.getAttribute('data-slug')));
            }
        })


        let params = new URLSearchParams();
        params.append('type', '242424')
        // @ts-ignore
        params.append('tag', urlParams.get('tag').split(','))
        params.append('category', urlParams.get('category') ?? '')
        let url = `/${lang}/?` + params.toString()

        // @ts-ignore
        fetch(url)
            .then(response => response.json())
            .then(data => {
                const container = document.querySelector('.wall')
                if(data && container) {
                    container.innerHTML = data.result

                    var msnry = new Masonry( '.wall', {"percentPosition": true, "originLeft": true })
                    msnry.layout()
                    document.querySelector('.loading-spinner').style.display = 'none'

                    const bricks = document.querySelectorAll('.wall__brick')
                    if (bricks.length >= data.itemsTotal) {
                        buttonMore.style.display = "none"
                    } else {
                        buttonMore.style.display = "inline-flex"
                    }
                }
            })
            .catch(error => console.error('Error:', error));

        if(!urlParams.get('tag')) {
            document.querySelector('#all-tags').classList.add('btn--active')
        } else {
            document.querySelector('#all-tags').classList.remove('btn--active')
        }

    })
})

buttonMore?.addEventListener('click', (e) => {
    e.preventDefault()
    let urlParams = new URLSearchParams(window.location.search);

    // Sprache aus URL extrahieren
    const pathParts = window.location.pathname.split('/');
    const lang = pathParts[1] || 'de';

    document.querySelector('.loading-spinner').style.display = 'flex'
    let params = new URLSearchParams();
    params.append('type', '242424');
    // @ts-ignore
    params.append('tag', urlParams.get('tag') ? urlParams.get('tag').split(',') : [])
    pageNumber += 1
    params.append('page', pageNumber)
    let url = `/${lang}/?` + params.toString();

    // @ts-ignore
    fetch(url)
        .then(response => response.json())
        .then(data => {
            const container = document.querySelector('.wall')
            if(data && container) {
                container.innerHTML += data.result

                var msnry = new Masonry( '.wall', {"percentPosition": true, "originLeft": true })
                setTimeout(() => {
                    msnry.layout();
                },500)
                document.querySelector('.loading-spinner').style.display = 'none'

                const bricks = document.querySelectorAll('.wall__brick')
                if (bricks.length >= data.itemsTotal) {
                    buttonMore.style.display = "none"
                } else {
                    buttonMore.style.display = "inline-flex"
                }
            }
        })
        .catch(error => console.error('Error:', error));
})

const buttonMorePress = document.querySelector('[data-presse-loadmore="#articles_main"]')
buttonMorePress?.addEventListener('click', (e) => {
    e.preventDefault()
    let urlParams = new URLSearchParams(window.location.search);

    // Sprache aus URL extrahieren
    const pathParts = window.location.pathname.split('/');
    const lang = pathParts[1] || 'de';

    document.querySelector('.loading-spinner').style.display = 'flex'
    let params = new URLSearchParams();
    params.append('type', '242424');
    // @ts-ignore
    pageNumber += 1
    params.append('page', pageNumber)
    params.append('presseOnly', 1)
    let url = `/${lang}/?` + params.toString();

    // @ts-ignore
    fetch(url)
        .then(response => response.json())
        .then(data => {
            const container = document.querySelector('.presse')
            if(data && container) {
                container.innerHTML += data.result

                document.querySelector('.loading-spinner').style.display = 'none'

                const bricks = document.querySelectorAll('.presse-item')
                if (bricks.length >= data.itemsTotal) {
                    buttonMorePress.style.display = "none"
                }
            }
        })
        .catch(error => console.error('Error:', error));
})
